<template>
  <div>
    <div
      style="width: calc(100vw - 36px);"
      :class="[
        'tw-fixed tw-flex tw-flex-col tw-z-40 tw-h-screen tw-left-0 tw-top-0 transition-slow menu-nav tw-overflow-auto tw-pb-8',
        { 'side-nav--open tw-shadow-xl': openNav && !isDesktopView },
        { 'side-nav--open tw-shadow-xl': isDesktopView && !fullAppView },
        { 'tw-bg-white': !isFlatSideNavView },
        { 'lg-app:tw-shadow-none tw-bg-transparent': isFlatSideNavView },
      ]"
      @click.stop="close()"
    >
      <TopNav
        logo
        title="eMentored"
        title-class="lg-app:tw-block tw-hidden pl-body"
        :show-notification-icon="false"
        :show-user-photo="isMobileView"
        bg-transparent
      >
        <button
          slot="left-action"
          v-show="!isDesktopView"
          class="top-nav__action tw-mr-4 pl-body"
          @click.stop="close()"
        >
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
            <path d="M56,4.2c0,1.2-0.4,2-1.2,2.9l-29,29l29,29c1.6,1.6,1.6,4.1,0,5.7s-4.1,1.6-5.7,0L17.2,39c-1.6-1.6-1.6-4.1,0-5.7l31.9-32
              c1.6-1.6,4.1-1.6,5.7,0C55.6,2.1,56,3,56,4.2z"/>
          </svg>
          <span class="tw-uppercase tw-align-middle">back</span>
        </button>
      </TopNav>

      <slot name="default" />
      <slot name="trigger" />

      <div class="tw-flex-grow"></div>
      <p class="tw-font-thin pl-body -tw-text-center tw-text-xs font-title opacity-31 tw-tracking-wider">
        {{ appVersion }}
      </p>
    </div>

    <!-- OVERLAY -->
    <transition name="fade" appear>
      <div
        v-show="openNav && !isDesktopView"
        @click.stop="close()"
        class="tw-fixed tw-w-screen tw-h-screen tw-bg-black opacity-54 tw-z-30 tw-left-0 tw-top-0"
      ></div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SideNav',
  data() {
    return {
      openNav: true,
    };
  },
  watch: {
    isMobileView(is) {
      if (is) {
        this.openNav = false;
      }
    },
    showMenuNav(show) {
      this.openNav = show;
    },
  },
  computed: {
    ...mapState({
      showMenuNav: state => state.ui.showMenuNav,
      fullAppView: state => state.ui.isFullAppView,
    }),
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },
  methods: {
    close() {
      this.$store.commit('showMenuNav', false);
      this.$emit('close');
    },
    open() {
      this.$emit('open');
    },
  },
  async created() {
    await this.$nextTick();
    this.openNav = this.showMenuNav;
  },
};
</script>

<style>
</style>
